<template>
  <component :is="href ? 'a' : 'div'" class="shiny relative inline-block py-3 px-6 rounded text-white hover:text-white text-center font-extrabold uppercase cursor-pointer" :href="href" :target="href ? '_blank' : null">
    <slot />
  </component>
</template>

<script>
  export default {
    name: 'UiButton',
    props: {
      href: {
        type: String,
        default: null,
      },
    },
  }
</script>
